<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Edycja zgłoszenia' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2 w-100">

            <div class="complaint-edit__select" *ngIf="hasAccessTo.editStatus && (statuses.length > 1 || statuses.length > 0 && statuses[0].id !== getActualStatusId(getUserType()))">
                <icc-select
                    [label]="'COMPLAINT|Status' | translate"
                    [value]="documentStatus"
                    (valueChange)="documentStatus = number($event)"
                    size="medium"
                    appearance="outline"
                >
                    <option *ngFor="let el of statuses" [value]="el.id" >
                        {{ el.name }}
                    </option>
                </icc-select>
            </div>

            <div class="complaint-edit__input">
                <icc-input
                    [(ngModel)]="documentName"
                    name="documentName"
                    [size]="'medium'"
                    [disabled]="!hasAccessTo.manageComplaint"
                    [placeholder]="'COMPLAINT|Indywidualny numer reklamacji' | translate"
                    [label]="'COMPLAINT|Indywidualny numer reklamacji' | translate"
                    type="text"
                    [maxLength]="255"
                ></icc-input>
            </div>

            <div class="complaint-edit__input" *ngIf="hasAccessTo.editComplaintOrderNumber">
                <icc-input
                    [(ngModel)]="documentComplaintOrderNumber"
                    name="complaintOrderNumber"
                    [size]="'medium'"
                    [placeholder]="'COMPLAINT|Numer zamówienia reklamacyjnego' | translate"
                    [label]="'COMPLAINT|Numer zamówienia reklamacyjnego' | translate"
                    type="text"
                    [maxLength]="255"
                ></icc-input>
            </div>

            <div class="complaint-edit__select" *ngIf="hasAccessTo.manageComplaint">
                <icc-select
                    [value]="documentComplaintType"
                    (valueChange)="documentComplaintType = $event; changedType();"
                    size="medium"
                    [label]="'COMPLAINT|Rodzaj zgłoszenia' | translate"
                    [required]="true"
                >
                    <option
                        *ngFor='let documentType of documentTypesDict | keyvalue'
                        [value]="documentType.key"
                    >
                        {{ documentType.value | translate }}
                    </option>
                </icc-select>
            </div>

            <div class="complaint-edit__input">
                <icc-input
                    [value]="documentPurchaseDate"
                    (valueChange)="documentPurchaseDate = $event"
                    name="declaredDeadline"
                    type="date"
                    [size]="'medium'"
                    [datePickerSide]="'left'"
                    [placeholder]="'COMPLAINT|Data zakupu' | translate"
                    [label]="'COMPLAINT|Data zakupu' | translate"
                    [disabled]="!hasAccessTo.manageComplaint"
                    #documentPurchaseDateInput
                    [required]="data.complaint.documentTypeId === documentTypes.complaint"
                    [dateErrorMessage]="'COMPLAINT|Wprowadź datę w formacie: dd.mm.rrrr' | translate"
                ></icc-input>
            </div>

            <div class="complaint-edit__select" *ngIf="hasAccessTo.editAssign && (objectLength(assignedToFilteredOptions) > 1 || getUserType() === 'manufacturer') && allPositionsHaveConfiguration() && !authorizedRetailerDistributorComplaint && !distributorManufacturerComplaint">
                <icc-select
                    [value]="documentAssignedTo"
                    (valueChange)="documentAssignedTo = $event"
                    size="medium"
                    [label]="'COMPLAINT|Podmiot przypisany' | translate"
                    [required]="true"
                    #assignedToInput
                >
                    <ng-container *ngIf="getUserType() === 'manufacturer'">
                        <option
                            *ngFor='let assignedToOption of (assignedToOptions | keyvalue)'
                            [value]="assignedToOption.key"
                        >
                            {{ assignedToOption.value }}
                        </option>
                    </ng-container>

                    <ng-container *ngIf="getUserType() !== 'manufacturer'">
                        <option
                            *ngFor='let assignedToOption of (assignedToFilteredOptions | keyvalue)'
                            [value]="assignedToOption.key"
                        >
                            {{ assignedToOption.value }}
                        </option>
                    </ng-container>
                </icc-select>
            </div>

            <div class="complaint-edit__select" *ngIf="hasAccessTo.editAssign">
                <icc-select
                    [value]="documentResponsibleUser"
                    (valueChange)="documentResponsibleUser = $event"
                    size="medium"
                    [label]="'COMPLAINT|Osoba odpowiedzialna' | translate"
                    [required]="true"
                    #responsibleUserInput
                >
                    <option
                        *ngFor='let worker of workersList | keyvalue'
                        [value]="worker.key"
                        [selected]="+worker.key === +data.complaint[getUserType()]?.userId"
                    >
                        {{ worker.value }}
                    </option>
                </icc-select>
            </div>

            <div class="complaint-edit__select" *ngIf="hasAccessTo.editAssign">
                <icc-select
                    [value]="documentAssignedUser"
                    (valueChange)="documentAssignedUser = $event"
                    size="medium"
                    [label]="'COMPLAINT|Przypisana osoba' | translate"
                    [required]="true"
                    #assignedUserInput
                >
                    <option
                        *ngFor='let worker of workersList | keyvalue'
                        [value]="worker.key"
                    >
                        {{ worker.value }}
                    </option>
                </icc-select>
            </div>

            <div class="complaint-edit__select">
                <div class="priority-edit-container">
                    <icc-select
                        [value]="documentPriorityGroup"
                        (valueChange)="documentPriorityGroup = $event"
                        size="medium"
                        [label]="'COMPLAINT|Priorytet' | translate"
                        [required]="true"
                        class="priority-edit-container__select"
                        [disabled]="!hasAccessTo.manageComplaint"
                        #priorityInput
                    >
                        <option
                            *ngFor="let priority of documentPriorities"
                            [value]="priority.value"
                        >
                            {{ priority.label | translate }}
                        </option>
                    </icc-select>
                    <div>
                    -
                    </div>
                    <icc-input
                        [(ngModel)]="documentPriorityValue"
                        name="priorityValue"
                        type="number"
                        size="medium"
                        [min]="1"
                        [max]="99"
                        [maxLength]="2"
                        [title]="'COMPLAINT|Wartość musi mieścić się w zakresie od 1 do 99' | translate"
                        class="priority-edit-container__input"
                        [disabled]="!hasAccessTo.manageComplaint"
                        #priorityValueInput="ngModel"
                    ></icc-input>
                </div>
            </div>
        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
